const NotificationToggle = ({ label, description, isEnabled, onToggle }) => (
  <div className="flex justify-between items-start pt-5 first:pt-0">
    <div>
      <h4 className="font-semibold text-secondary-800">{label}</h4>
      <p className="text-sm text-secondary-600">{description}</p>
    </div>
    <button
      onClick={onToggle}
      className={`w-12 h-6 flex items-center rounded-full p-1 duration-300 ease-in-out ${
        isEnabled ? "bg-primary-600" : "bg-gray-300"
      }`}
    >
      <div
        className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ease-in-out ${
          isEnabled ? "translate-x-6" : ""
        }`}
      ></div>
    </button>
  </div>
);

export default NotificationToggle;